import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataStackedByAnswer
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import StackedByAnswer from "../../charts/stackedBarChart/stackedByAnswer";
import InstitutionN from "../../components/InstitutionN";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";

const ApplicationsAndOffers = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponseA, setApiResponseA] = useState<NestedResponseData | null>(null);
  const [apiResponseB, setApiResponseB] = useState<NestedResponseData | null>(null);
  const [transformedResponseA, setTransformedResponseA] = useState<TransformedData[] | null>(null);
  const [transformedResponseB, setTransformedResponseB] = useState<TransformedData[] | null>(null);
  const [institutionNresponseA, setInstitutionNresponseA] = useState(0);
  const [institutionNresponseB, setInstitutionNresponseB] = useState(0);


  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {
    const getDataSubsectionA = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section4/subsection3a/?report_year=${year}&group_by=${selectedFilter}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponseA(data);
        setTransformedResponseA(transformDataStackedByAnswer(data, "4.3a", selectedFilter));
        setInstitutionNresponseA(data.institution.total.total)
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getDataSubsectionB = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section4/subsection3b/?report_year=${year}&group_by=${selectedFilter}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponseB(data);
        setTransformedResponseB(transformDataStackedByAnswer(data, "4.3b", selectedFilter));
        setInstitutionNresponseB(data.institution.total.total);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getDataSubsectionA();
    getDataSubsectionB();
  }, [getAccessTokenSilently, selectedFilter, year]);

  return (
    <>
      <h2>4.3 Applications sent and offers received</h2>

      <FilterDropdown setSelectedFilter={setSelectedFilter} />
      <p>
        While at your institution, to how many external positions did you apply in the three years prior to the current academic year?
      </p>

      <h4>Numbers of positions applied to</h4>
      {!transformedResponseA && <PageLoader />}
      {transformedResponseA &&
        <>
          <InstitutionN institutionN={institutionNresponseA} />
          <StackedByAnswer
            data={transformedResponseA}
            section="4.3a"
            sequential={true}
            institutionN={institutionNresponseA}
            selectedFilter={selectedFilter}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponseA}
            selectedFilter={selectedFilter}
            filename="4.3a_Numbers_of_positions_applied"
            section="4.3a"
          />
        </>
      }

      <h4>Numbers of offers received</h4>
      <p>
        How many job offers did you receive during your most recent academic year at your institution?
      </p>
      {!transformedResponseB && <PageLoader />}
      {transformedResponseB &&
        <>
          <InstitutionN institutionN={institutionNresponseB} />
          <StackedByAnswer
            data={transformedResponseB}
            section="4.3b"
            sequential={true}
            institutionN={institutionNresponseB}
            selectedFilter={selectedFilter}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponseB}
            selectedFilter={selectedFilter}
            filename="4.3b_Numbers_of_offers_received"
            section="4.3b"
          />
        </>
      }

      
    </>
  )
}

export default ApplicationsAndOffers;